import { Dispatch } from 'redux';
import { countriesApi } from '../../apis/common';
import { Country } from '../../interfaces/location';
import { FetchCountriesAction } from '../actions/country.action';
import { ActionType } from '../action_types';

export const fetchCountries = () => async (dispatch: Dispatch<FetchCountriesAction>) => {
  try {
    const response = await countriesApi();
    const countries: Country[] = response.data;
    const sortedCountries = countries.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    dispatch({
      type: ActionType.FETCH_COUNTRIES,
      payload: {
        countries: sortedCountries,
      },
    });
  } catch (error) {}
};
